/* ==========================================================================
   HUSSIENI HOME — CONFIGURED VIEW IN THE MAIN GALLERY

   The point of the configurator is that the piece on the page changes. This
   file drives that: when the current selection has a prepared photograph or
   render, that image becomes the main image in the gallery. When it does not,
   the original photographs stay — but they are labelled as reference shots,
   never passed off as a picture of the chosen combination.

   Rules this file exists to honour:
   - No CSS filter over the photograph, no colour wash across background,
     wood and shadow. Either a real image of that combination exists, or the
     page says so.
   - The selection, the summary, the 3D view and the cart all read from the
     same checked radios, so they cannot disagree.
   - Fast switching ends on the customer's last choice, not on whichever
     network request happened to finish last.
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var cfgRoot = document.querySelector('[data-hh-cfg]');
    var gallery = document.querySelector('[data-hh-gallery]');
    if (!cfgRoot || !gallery) return;
    if (gallery.dataset.hhGalReady === '1') return;
    gallery.dataset.hhGalReady = '1';

    var cfg;
    try { cfg = JSON.parse(cfgRoot.querySelector('[data-hh-cfg-data]').textContent); }
    catch (e) { return; }

    var previews = cfg.previews || {};
    var hasAny = Object.keys(previews).length > 0;

    var figure = gallery.querySelector('[data-hh-configured]');
    var img = figure ? figure.querySelector('img') : null;
    var note = document.querySelector('[data-hh-gallery-note]');
    var originals = [].slice.call(gallery.querySelectorAll('[data-hh-shot]'));
    var token = 0;

    function key() {
      var parts = [];
      cfgRoot.querySelectorAll('[data-hh-cfg-group]').forEach(function (g) {
        var r = g.querySelector('.hh-cfg__radio:checked');
        if (r) parts.push(g.dataset.hhCfgGroup + ':' + r.dataset.hhCfgOption);
      });
      return parts.sort().join('|');
    }

    function markOriginals(isReference) {
      originals.forEach(function (f) {
        f.classList.toggle('is-reference', isReference);
      });
    }

    function showConfigured(match, mine) {
      // Decode before swapping so the gallery never flashes a half-painted
      // image, and drop the result if a newer selection has arrived.
      var next = new Image();
      next.src = match.url;
      var done = function () {
        if (mine !== token) return;
        img.src = match.url;
        img.alt = match.alt || cfg.productTitle;
        figure.hidden = false;
        markOriginals(true);
        if (note) {
          note.textContent = cfg.strings.previewMatch;
          note.hidden = false;
        }
      };
      if (next.decode) next.decode().then(done).catch(done);
      else { next.onload = done; next.onerror = done; }
    }

    function showOriginals(mine) {
      if (mine !== token) return;
      if (figure) { figure.hidden = true; img.removeAttribute('src'); }
      markOriginals(false);
      if (!note) return;
      if (hasAny) {
        // Some combinations are pictured, this one is not. Say so plainly.
        note.textContent = cfg.strings.previewUnavailable + ' ' + cfg.strings.previewOriginalNote;
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }

    function sync() {
      var mine = ++token;
      var match = previews[key()];
      if (match && match.url && figure && img) showConfigured(match, mine);
      else showOriginals(mine);
    }

    cfgRoot.addEventListener('change', function (e) {
      if (e.target.matches('.hh-cfg__radio')) sync();
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();